import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import filePickerComponent from "@/components/child/form/filepicker.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ListComponentBase from "@/components/parent/crud/listComponentBase";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import FormulaPadraoAnexoService from "@/services/anexo/formulaPadraoAnexoService";
import { IServiceAnexo } from "@/services/base/iServiceAnexo";
import ClienteAnexoService from "@/services/clienteAnexoService";
import ControleReclamacaoAnexoService from "@/services/controleReclamacaoAnexoService";
import ProdutoAnexoService from "@/services/produtoAnexoService";
import ProdutoLoteAnexoService from "@/services/produtoLoteAnexoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import { Getters } from "@/store/store";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";
import { AnexoServiceName } from "@/utils/common/constants";
import Delay from "@/utils/common/delay";
import FileHelper from "@/utils/common/fileHelper";
import { DocumentFileType, ImageFileType } from "@/utils/fileExtensions";
import { mapGetters } from "vuex";

export class ModelUpload {
    id?: number = null;
    descricao: string = null;
    file: File;
    dataCriacao?: Date = null;
    laudoTecnico?: boolean = false;
    produtoLoteId?: number = null;
}

@Component({
    components: {
        filePickerComponent,
        fieldsetComponent,
        shortcutComponent,
        buttonIncluirComponent,
        dateTimePickerComponent,
        checkboxComponent,
        comboComponent,
    },
    computed: {
        ...mapGetters(["VALIDAR_PERMISSAO_SOMENTE_CONSULTA", "GET_IS_FRACIONAMENTO"] as Getters),
    },
})
export default class UploadAnexoComponent extends ListComponentBase<any> {
    // State computed props
    VALIDAR_PERMISSAO_SOMENTE_CONSULTA: (telaDescricao: string) => boolean;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;

    serviceInstance: IServiceAnexo | null = null;
    serviceList = new Map<string, any>([
        [AnexoServiceName.ProdutoLoteAnexo, ProdutoLoteAnexoService],
        [AnexoServiceName.ProdutoAnexo, ProdutoAnexoService],
        [AnexoServiceName.ControleReclamacaoAnexo, ControleReclamacaoAnexoService],
        [AnexoServiceName.ClienteAnexo, ClienteAnexoService],
        [AnexoServiceName.FormulaPadraoAnexo, FormulaPadraoAnexoService],
    ]);

    private shortCutComponent: ShortcutComponent = null;
    private loadUploadComponent = false;

    gridSelectedValues: Array<any> = [];
    extraActions: Array<object> = [];
    extraActionsView: GridAction[] = [];
    extraActionsDownload: GridAction[] = [];
    modelsUpload: ModelUpload[] = [];
    deleteIds: ModelUpload[] = [];
    isFracionamento = false;

    get isLaudoTecnicoVisible(): boolean {
        return this.serviceUpload === AnexoServiceName.ProdutoLoteAnexo && this.isFracionamento;
    }

    get isProdutoLoteVisible(): boolean {
        return this.serviceUpload === AnexoServiceName.ProdutoAnexo;
    }

    get gridColumns(): Array<GridColumn> {
        const columns = [
            new GridColumn("dataCriacao", "Data Inclusão", GridColumnType.DateTime),
            new GridColumn("descricao", "Descrição", GridColumnType.String),
        ];

        if (this.isLaudoTecnicoVisible) {
            columns.push(new GridColumn("laudoTecnico", "Laudo Técnico", GridColumnType.Boolean));
        }

        if (this.isProdutoLoteVisible) {
            columns.push(new GridColumn("produtoLoteDescricao", "Lote", GridColumnType.String));
        }

        return columns;
    }

    selectedFile: File | null = null;
    produtoLoteOptions: Array<Object> = [];
    somenteConsultaVenda = false;
    newRequest = true;

    @Prop(Number) id: number;
    @Prop(String) serviceUpload: string;

    model = null;

    private async onView(fileUpload: any) {
        const response = await this.serviceInstance!.get(fileUpload.id);
        FileHelper.openBlank(response);
    }

    public async show() {
        while (!this.$refs.shortCutComponent) await Delay(50);
        this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
        this.shortCutComponent.title = this.$t("__.Crud.produtolote.edit_vue_html.uploadAnexo") as string;
        this.loadUploadComponent = true;

        await this.load();
        await this.loadProdutoLoteOptions();

        this.shortCutComponent.show();
    }

    public async loadMethod() {
        if (this.newRequest) {
            this.somenteConsultaVenda = this.VALIDAR_PERMISSAO_SOMENTE_CONSULTA("vendas");
            this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
            this.createServiceInstance();

            try {
                if (this.id) {
                    this.newRequest = false;
                    return await this.serviceInstance!.listFiles(this.id)
                        .withLoading()
                        .resolveWithJSON<PaginationModel<any>>();
                }
            } catch {}
        }
    }

    private createServiceInstance() {
        if (this.serviceUpload && this.serviceInstance == null) {
            this.serviceInstance = new (this.serviceList.get(this.serviceUpload))() as IServiceAnexo;
        }
    }

    private async loadProdutoLoteOptions() {
        this.produtoLoteOptions = [];

        if (!this.isProdutoLoteVisible || !this.id) {
            return;
        }

        try {
            const data = await new ProdutoLoteService()
                .getByProdutoId(this.id, 0)
                .withLoading()
                .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

            this.produtoLoteOptions = data.list.map(item => getProdutoLoteCombo(item, this.isFracionamento));
        } catch {}
    }

    public async afterLoad() {
        this.extraActions.splice(0);
        this.extraActionsView.splice(0);
        this.extraActionsDownload.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            if (this.gridData[i].id) {
                this.extraActionsView.push(new GridAction("visualizar", "Visualizar", "fa fa-eye", GridColors.BLUE));
                this.extraActionsDownload.push(
                    new GridAction("baixar", "Baixar Arquivo", "fa fa-download", GridColors.GREEN),
                );
            }
        }

        this.extraActions.push(this.extraActionsView);
        this.extraActions.push(this.extraActionsDownload);
    }

    private onExtraActions(name: string, model: any) {
        if (name.trim() == "visualizar") {
            this.onView(model);
        }

        if (name.trim() == "baixar") {
            this.onDownload(model);
        }
    }

    public async afterMounted() {
        this.model = new ModelUpload();
    }

    private clear() {
        this.afterMounted();
        this.selectedFile = null;
    }

    private async onInclusaoFile() {
        if (!this.selectedFile) {
            return;
        }

        const isValid = await this.$validator.validateAll();
        if (isValid) {
            if (!this.selectedFile.isImage() && !this.selectedFile.isDocument()) {
                const allowedFileTypes = [...Object.keys(DocumentFileType), ...Object.keys(ImageFileType)];
                this.$showError(
                    this.$t("__.ts.tipoArquivoInvalido"),
                    `${this.$t("__.ts.exemplosTipoArquivoPermitido")} ${allowedFileTypes.join(", ")}`,
                );
                this.selectedFile = null;
                return;
            }

            const maxFileSize = 25 * 1024 * 1024; // Faz assim pois size está em bytes;
            if (this.selectedFile.size > maxFileSize) {
                this.$showError(this.$t("__.ts.arquivoMuitoGrande"), this.$t("__.ts.tamanhoMaximoArquivo25mb"));
                this.selectedFile = null;
                return;
            }

            this.modelsUpload.push({
                descricao: this.model.descricao,
                file: this.selectedFile,
                laudoTecnico: this.model.laudoTecnico,
                produtoLoteId: this.model.produtoLoteId,
            });

            this.gridData.push({
                descricao: this.model.descricao,
                selectedFile: this.selectedFile,
                dataCriacao: new Date(),
                laudoTecnico: this.model.laudoTecnico,
                produtoLoteDescricao: this.getProdutoLoteDescricao(this.model.produtoLoteId),
            });
            this.clear();
        }
    }

    private getProdutoLoteDescricao(produtoLoteId?: number) {
        if (!produtoLoteId) {
            return null;
        }

        const produtoLote = this.produtoLoteOptions.find(p => p["value"] == produtoLoteId);

        return produtoLote ? produtoLote["text"] : null;
    }

    private async insertFile(id: number, descricao: string, file: File) {
        try {
            await this.serviceInstance.insertFile(id, descricao, file).withLoading().resolveWithoutJSON();
            return true;
        } catch {}
        return false;
    }

    private async onDownload(fileUpload: any) {
        const response = await this.serviceInstance.get(fileUpload.id);

        const blob = await response.blob();
        const fileName = response.headers
            .get("Content-Disposition")
            .split("filename=")[1]
            .split(";")[0]
            .trim()
            .replace(/^"|"$/g, "");
        FileHelper.download(blob, fileName);
    }

    private async onDelete(fileUpload: any) {
        if (fileUpload.id) {
            this.deleteIds.push(fileUpload);
        }
        this.gridData = this.gridData.filter(p => p != fileUpload);
        this.modelsUpload = this.modelsUpload.filter(
            p => p.file != fileUpload.file && p.descricao != fileUpload.descricao,
        );
        this.afterLoad();
    }

    public async onSucessoSave(id?: number) {
        if (this.deleteIds.length > 0) {
            await this.serviceInstance!.delete(this.deleteIds.map(p => p.id!))
                .withLoading()
                .resolveWithoutJSON();
        }

        for (const item of this.modelsUpload) {
            if (!item.id) {
                if (this.isLaudoTecnicoVisible) {
                    (this.serviceInstance as ProdutoLoteAnexoService).insertLaudoTecnico(
                        id,
                        item.descricao,
                        item.laudoTecnico,
                        item.file,
                    );
                } else if (this.isProdutoLoteVisible) {
                    (this.serviceInstance as ProdutoAnexoService).insertFileComProdutoLote(
                        id,
                        item.descricao,
                        item.produtoLoteId,
                        item.file,
                    );
                } else {
                    this.serviceInstance!.insertFile(id, item.descricao, item.file);
                }
            }
        }
    }
}
